export default __webpack_public_path__ + "static/cover-big-te-4d56794b7d939d477aa56e5a8921ab50.png";